import React, { useState } from 'react';
import { IoMdClose } from 'react-icons/io';
import { CgMenuRight } from 'react-icons/cg';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Socialmedia from './Socialmedia';
import { useTheme } from '../context/ThemeContext';

const menuVariants = {
  hidden: {
    x: '100%',
  },
  show: {
    x: 0,
    transition: {
      ease: [0.6, 0.01, -0.05, 0.9],
    },
  },
};

const MobileNav = () => {
  const [openMenu, setOpenMenu] = useState(false);
  const theme = useTheme();
  const darkMode = theme?.darkMode ?? true;
  const toggleTheme = theme?.toggleTheme;

  const iconColor = darkMode ? 'text-white' : 'text-black';
  const menuBg = darkMode
    ? 'bg-gradient-to-br from-indigo-950 via-slate-950 to-black'
    : 'bg-white';
  const linkColor = darkMode ? 'text-gray-200' : 'text-black';
  const closeColor = darkMode ? 'text-gray-200' : 'text-black';

  return (
    <nav className={`xl:hidden ${iconColor}`}>
      {/* Nav open button */}
      <div
        onClick={() => setOpenMenu(true)}
        className="text-3xl cursor-pointer"
      >
        <CgMenuRight />
      </div>

      {/* Menu */}
      <motion.div
        variants={menuVariants}
        initial="hidden"
        animate={openMenu ? 'show' : ''}
        className={`fixed inset-0 ${menuBg} shadow-2xl z-50 transition-colors duration-300`}
      >
        {/* Close icon */}
        <div
          onClick={() => setOpenMenu(false)}
          className={`text-4xl absolute left-4 top-14 cursor-pointer z-50 ${closeColor}`}
        >
          <IoMdClose />
        </div>

        {/* Theme toggle */}
        <button
          onClick={toggleTheme}
          aria-label="Toggle theme"
          className={`absolute right-4 top-14 w-8 h-8 flex items-center justify-center rounded-full border transition ${iconColor} ${
            darkMode
              ? 'border-white/20 hover:border-white/60'
              : 'border-black/20 hover:border-black/60'
          }`}
        >
          {darkMode ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-4 h-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={1.5}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364-6.364-.707.707M6.343 17.657l-.707.707M17.657 17.657l-.707-.707M6.343 6.343l-.707-.707M12 7a5 5 0 100 10A5 5 0 0012 7z"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-4 h-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={1.5}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21 12.79A9 9 0 1111.21 3a7 7 0 009.79 9.79z"
              />
            </svg>
          )}
        </button>

        {/* Menu links + social icons */}
        <div className="flex flex-col justify-center items-center h-full gap-y-10">
          <ul className={`flex flex-col items-center gap-y-10 font-primary font-bold text-3xl ${linkColor}`}>
            <li>
              <Link onClick={() => setOpenMenu(false)} to="/" className="hover:opacity-50 transition">
                Home
              </Link>
            </li>
            <li>
              <Link onClick={() => setOpenMenu(false)} to="/about" className="hover:opacity-50 transition">
                About
              </Link>
            </li>
            <li>
              <Link onClick={() => setOpenMenu(false)} to="/portfolio" className="hover:opacity-50 transition">
                Portfolio
              </Link>
            </li>
            <li>
              <Link onClick={() => setOpenMenu(false)} to="/prints" className="hover:opacity-50 transition">
                Prints
              </Link>
            </li>
            <li>
              <Link onClick={() => setOpenMenu(false)} to="/blog" className="hover:opacity-50 transition">
                Blog
              </Link>
            </li>
            <li>
              <Link onClick={() => setOpenMenu(false)} to="/contact" className="hover:opacity-50 transition">
                Contact
              </Link>
            </li>
          </ul>

          {/* Social icons */}
          <div className="flex sm:mx xl:flex mx-auto">
            <Socialmedia />
          </div>
        </div>
      </motion.div>
    </nav>
  );
};

export default MobileNav;